
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.833.042H3.167A2.292 2.292 0 00.875 2.333v8.334c0 .981.46 1.906 1.242 2.5L9 18.35l6.883-5.183a3.142 3.142 0 001.242-2.5V2.333A2.292 2.292 0 0014.833.042zm1.042 10.625a1.9 1.9 0 01-.742 1.5L9 16.783l-6.133-4.641a1.9 1.9 0 01-.742-1.475V2.333c0-.575.466-1.041 1.042-1.041h11.666c.576 0 1.042.466 1.042 1.041v8.334zM12.45 4.4l.9.833-5.183 5.434-3.034-3.034.884-.883 2.15 2.158L12.45 4.4z","fill-rule":"nonzero","fill":"#000"}})])
          )
        }
      }
    